import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Close from "@mui/icons-material/Close";
import Fingerprint from "@/component/icons/sf-fingerprint";
import Face from "@mui/icons-material/Face";
import SFCheckCircleIcon from "../icons/sf-check-circle-icon";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import SFFaceIcon from "../icons/sf-face-icon";

type AddSecureDrawerProps = {
  open: boolean;
  onClose: () => void;
};

function AddSecureDrawer({ open, onClose }: AddSecureDrawerProps) {
  const theme = useTheme();
  const [status, setStatus] = useState("initial");

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          p: 3,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 0, top: 0, p: 0 }}
        >
          <Close />
        </IconButton>

        {status === "initial" && (
          <Box>
            <Typography variant="h5" fontWeight={700} mb={3}>
              추가 인증 수단 등록하기
            </Typography>
            <Typography variant="body2">
              간편 비밀번호 입력없이 빠르게
            </Typography>
            <Typography variant="body1" mb={5}>
              <b>지문인증</b> 또는 <b>Face ID</b>로 로그인하세요!
            </Typography>
            <Stack direction="row" gap={2}>
              <Button
                startIcon={<Fingerprint />}
                onClick={() => setStatus("fingerprint")}
                fullWidth
                size="large"
                variant="contained"
              >
                지문인증
              </Button>
              <Button
                startIcon={<SFFaceIcon />}
                onClick={() => setStatus("faceId")}
                fullWidth
                size="large"
                variant="contained"
              >
                Face ID
              </Button>
            </Stack>
          </Box>
        )}

        {status === "fingerprint" && (
          <Box>
            <Typography variant="h5" fontWeight={700} mb={5}>
              지문 등록 하기
            </Typography>
            <Stack alignItems="center" gap={3}>
              <Fingerprint
                color={theme.palette.primary.main}
                strokeWidth={1.5}
                style={{ fontSize: 60 }}
              />
              <Typography variant="body1" color="primary" fontWeight={700}>
                지문을 인식해 주세요.
              </Typography>
            </Stack>
          </Box>
        )}

        {status === "faceId" && (
          <Box>
            <Typography variant="h5" fontWeight={700} mb={5}>
              지문 등록 하기
            </Typography>
            <Stack alignItems="center" gap={3}>
              <SFCheckCircleIcon
                color={theme.palette.primary.main}
                strokeWidth={1.5}
                style={{ fontSize: 60 }}
              />
              <Typography variant="body1" color="primary" fontWeight={700}>
                지문 등록이 완료되었습니다!
              </Typography>
            </Stack>
          </Box>
        )}
      </Box>
    </Drawer>
  );
}

export default AddSecureDrawer;
